<template>
    <div class="category-icon">
        <svg v-if="selected" width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19 56.9998L28 52.4997V44.4997L57 56.9997L19 56.9998Z" :fill="currentColor" />
            <path d="M8.67673e-06 56.9998L0 19.9998L4.50001 35.9998L8.5 43.9998L18.5 44.9998L9 56.9998H8.67673e-06Z"
                :fill="currentColor" />
            <path d="M1.61732e-06 -0.000244141H33L25 5.49976L13 8.49976L12 18.4998L1.61732e-06 9.99976V-0.000244141Z"
                :fill="currentColor" />
            <path
                d="M57 -0.000244141V9.99976L49.5 7.99975L39 29.9998L24.5 29.9998L20 39.4998L6 23.4998H14.5L22 19.9998L23 12.9998L41.5 3.99975L43 -0.000244141L57 -0.000244141Z"
                :fill="currentColor" />
            <path d="M37 36.9998L49 32.9998L57 19.9998L57 46.9998L37 36.9998Z" :fill="currentColor" />
        </svg>
        <svg v-else width="57" height="57" viewBox="0 0 57 57" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M54.5771 56.4998H21.1182L28.2236 52.947L28.5 52.8083V45.2595L54.5771 56.4998ZM4.01855 36.1355L4.03125 36.1804L8.17578 44.4695L8.4502 44.4968L17.54 45.405L8.75879 56.4998H0.5V23.6248L4.01855 36.1355ZM56.5 46.1902L38.3037 37.0925L49.1582 33.4744L49.3301 33.4167L49.4258 33.2615L56.5 21.7654V46.1902ZM56.5 0.499756V9.34839L49.6289 7.51636L49.2275 7.40991L49.0488 7.78394L38.6846 29.4998H24.1836L24.0479 29.7859L19.874 38.5964L7.10156 23.9998H14.6113L14.7119 23.9529L22.2119 20.4529L22.457 20.3386L22.4951 20.0701L23.457 13.3328L41.7188 4.44897L41.8984 4.36206L41.9678 4.17554L43.3467 0.499756H56.5ZM31.3896 0.499756L24.791 5.03589L12.8789 8.0144L12.5371 8.10034L12.5029 8.44995L11.5879 17.5945L0.5 9.74097V0.499756H31.3896Z"
                :stroke="currentColor" />
        </svg>
        <div v-if="hasText" class="navbar-text-desc">
            <p>other</p>
        </div>
    </div>
</template>

<style scoped>
.category-icon {
    width: v-bind(width);
    height: v-bind(height);
    display: flex;
    gap: 14px;
}

svg {
    height: v-bind(height);
}

.navbar-text-desc p {
    width: 40px;
}
</style>

<script setup>
import { useThemeStore } from '@/stores/useThemeStore';
import { computed } from 'vue';

const currentColor = computed(() => (useThemeStore.isDark ? "#E8E8E8" : "#000000"))

const props = defineProps({
    selected: {
        type: Boolean,
        default: false
    },
    hasText: {
        type: Boolean,
        default: false
    },
    width: {
        type: String,
        default: '153px'
    },
    height: {
        type: String,
        default: 'auto'
    }
})
</script>